var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBtnClear = function SvgBtnClear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F5F5FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9391 15.9994L19.803 13.1418C19.9284 13.0164 19.9988 12.8462 19.9988 12.6688C19.9988 12.4915 19.9284 12.3213 19.803 12.1959C19.6775 12.0705 19.5074 12 19.3301 12C19.1527 12 18.9826 12.0705 18.8572 12.1959L16 15.0602L13.1428 12.1959C13.0173 12.0705 12.8472 12 12.6699 12C12.4925 12 12.3224 12.0705 12.197 12.1959C12.0716 12.3213 12.0011 12.4915 12.0011 12.6688C12.0011 12.8462 12.0716 13.0164 12.197 13.1418L15.0609 15.9994L12.197 18.857C12.1346 18.919 12.085 18.9926 12.0512 19.0738C12.0174 19.155 12 19.2421 12 19.33C12 19.4179 12.0174 19.505 12.0512 19.5862C12.085 19.6673 12.1346 19.741 12.197 19.8029C12.2589 19.8654 12.3326 19.9149 12.4137 19.9487C12.4949 19.9826 12.582 20 12.6699 20C12.7578 20 12.8449 19.9826 12.926 19.9487C13.0072 19.9149 13.0808 19.8654 13.1428 19.8029L16 16.9386L18.8572 19.8029C18.9191 19.8654 18.9928 19.9149 19.0739 19.9487C19.1551 19.9826 19.2422 20 19.3301 20C19.418 20 19.5051 19.9826 19.5862 19.9487C19.6674 19.9149 19.741 19.8654 19.803 19.8029C19.8654 19.741 19.9149 19.6673 19.9487 19.5862C19.9826 19.505 20 19.4179 20 19.33C20 19.2421 19.9826 19.155 19.9487 19.0738C19.9149 18.9926 19.8654 18.919 19.803 18.857L16.9391 15.9994Z",
    fill: "#9595B1",
    stroke: "#9595B1",
    strokeWidth: 0.207407
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtnClear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btnClear.59df4892.svg";
export { ForwardRef as ReactComponent };